import config from '../../config'
import { HTTP } from  '../../http'
const pageSize = 15

export default {
    findAll: (keywords, documentNumber, salesPersonId, page) => {
        return new Promise((resolve, reject) => {            
            HTTP.get(`${config.apiEndpoints.sellersUri}search?keywords=${keywords}&documentNumber=${documentNumber}&pageSize=${pageSize}&page=${page}&salespersonid=${salesPersonId}` ).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    all: (keywords) => {
        return new Promise((resolve, reject) => {
            HTTP.get(config.apiEndpoints.sellersUri.concat(`?keywords=${keywords}`)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    allBySalesman: (keywords, salesmanId) => {
        return new Promise((resolve, reject) => {
            HTTP.get(config.apiEndpoints.sellersUri.concat(`?keywords=${keywords}&salesmanId=${salesmanId}`)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    allByAcquirerName: (keywords) => {
        return new Promise((resolve, reject) => {
            HTTP.get(config.apiEndpoints.sellersUri.concat(`?keywords=${keywords}&type=2`)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    find: (sellerId) =>{
        return new Promise((resolve, reject) => {
            HTTP.get(config.apiEndpoints.sellersUri.concat(sellerId)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    findDetailed: (sellerId) =>{
        return new Promise((resolve, reject) => {
            HTTP.get(config.apiEndpoints.sellersUri.concat(`${sellerId}/details`)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    current: () =>{
        return new Promise((resolve, reject) => {
            HTTP.get(config.apiEndpoints.sellersUri.concat('current')).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    createSeller: (seller) => {
        return new Promise((resolve, reject) => {
            HTTP.post(config.apiEndpoints.sellersUri, seller).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    updateSeller: (seller) => {
        return new Promise((resolve, reject) => {
            HTTP.put(config.apiEndpoints.sellersUri, seller).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    setSalesPerson: (entity) => {
        return new Promise((resolve, reject) => {
            HTTP.put(config.apiEndpoints.sellersUri.concat(`${entity.sellerId}/salesperson/${entity.salesPersonId}`)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    }
}